import styled from '@emotion/styled'

const ONBOARDING_IMAGE_SIZE = 264

export const StepContainerImageWrapper = styled.div`
  width: ${ONBOARDING_IMAGE_SIZE}px;
  height: ${ONBOARDING_IMAGE_SIZE}px;

  img,
  svg {
    width: 100%;
    height: 100%;
  }
`
